import FileUploadError from '../lib/error/errors/FileUploadError'
import ServerError from '../lib/error/errors/ServerError'

/**
 * Provides functionality for uploading files
 *
 * @class
 * @alias api.upload
 */
class Upload {

    /** @hideconstructor */
    constructor(api) {
        this.api = api
    }

    /**
     * Upload local file via router /api/binary.
     *
     * @param {File} file - The file
     * @param {{imType: string}} params - Object containing imType property to describe the uploaded file
     *
     * @returns {Promise<any>}
     */
    uploadFile(file, params) {
        return new Promise((resolve, reject) => {
            this.api.router.postBinary(
                '/api/binary',
                file,
                function(evt) {  // eslint-disable-line
                    // var progress = (evt.loaded / evt.total) * 100;
                },
                function(evt) {
                    try {
                        // If status ok, update document with image and return
                        if (evt.target.status === 200) {
                            resolve(evt.target.responseText)
                        }
                        else {
                            // Use ServerError to correctly handle server errors
                            const serverError = new ServerError(evt.target.responseText)
                            reject(new FileUploadError(serverError.message))
                        }
                    }
                    catch(ex) {
                        reject(ex)
                    }
                },
                function(e) {
                    reject(e)
                },
                params
            )
        })
    }

    /**
     * Send a uri to be uploaded to backend
     *
     * @param {string} uri
     * @param {{imType: string}} params
     * @returns {Promise<any>}
     */
    uploadUri(uri, params) {
        const router = this.api.router

        return new Promise((resolve, reject) => {
            router.get('/api/binary', {source: uri, imType: params.imType})
                .then(response => router.checkForOKStatus(response))
                .then(response => response.text())
                .then(function(xmlString) {
                    resolve(xmlString)
                })
                .catch((e) => {
                    reject(new FileUploadError(e.message ? e.message : e))
                })
        })
    }
}

export {Upload}
